import { get, isObject } from "lodash";

const getErrorList = state => path => get(state.errors, path, {});

const getCommonErrors = state => state.commonErrors;

const getErrors = state => (path, separator = "|") => {
  if (path.includes(separator)) {
    path = path.split(separator);
    path = path.shift();
  }
  let errors = get(state.errors, path, null);

  if (isObject(errors)) {
    const errorList = errors.errors || errors;

    errors = Object.values(errorList).join("<br/>");
  }

  return errors;
};

export default {
  getErrorList,
  getErrors,
  getCommonErrors
};
